export enum AppServiceBadgeStatus {
  INFO = 0,
  SUCCESS = 1,
  WARNING = 2,
  ERROR = 3,
  INACTIVE = 4,
}

export enum AppServiceBadgeMode {
  BOLD = 0,
  FILL = 1,
  OUTLINE = 2,
}
